import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'lib/components/table/table'

// Temporary mock data for billing history
const mockBillingHistory = [
  {
    id: '2025TEST-0007',
    date: '2025-06-01',
    amount: 100,
    currency: 'USD',
    status: 'Draft',
  },
  {
    id: '2025TEST-0008',
    date: '2025-04-01',
    amount: 200,
    currency: 'USD',
    status: 'Paid',
  },
  {
    id: '2025TEST-0009',
    date: '2025-03-01',
    amount: 150,
    currency: 'USD',
    status: 'Paid',
  },
]

export default function BillingHistory() {
  return (
    <div className="tw-container tw-w-full tw-grow">
      <div className="tw-block tw-w-full tw-overflow-x-auto tw-rounded-lg tw-bg-white tw-p-4 tw-shadow-md">
        <div className="tw-mb-4 tw-flex tw-items-center tw-justify-between">
          <strong>Billing History</strong>
        </div>
        <Table>
          <TableHeader>
            <TableRow intent="header">
              <TableHead className="tw-w-1/4 tw-px-2">Invoice ID</TableHead>
              <TableHead className="tw-w-1/4 tw-px-2">Amount</TableHead>
              <TableHead className="tw-w-1/4 tw-px-2">Date</TableHead>
              <TableHead className="tw-w-1/4 tw-px-2">Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {mockBillingHistory.map((billing) => (
              <TableRow key={billing.id} intent="body">
                <TableCell className="tw-w-1/4 tw-px-2">{billing.id}</TableCell>
                <TableCell className="tw-w-1/4 tw-px-2">
                  {billing.currency === 'USD' ? '$' : billing.currency} {billing.amount}
                </TableCell>
                <TableCell className="tw-w-1/4 tw-px-2">{billing.date}</TableCell>
                <TableCell className="tw-w-1/4 tw-px-2">{billing.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
